<script>
import vSelect from "vue-select";
import buscador from "./Buscador";
import UrlPopover from "./UrlPopover";

export default {
  mixins: [buscador],
  components: { vSelect, UrlPopover },
};
</script>

<template>
  <form
    method="POST"
    :action="urlAction"
    class="list-group mkte_circuitos-buscador buscador-horizontal"
    :class="{ 'is-admin': isAdmin }"
  >
    <div class="list-group-item">
      <div class="row row-0">
        <div class="col-xs-12 col-sm-12 col-md-11">
          <div class="row row-0">
            <div
              class="col-xs-12 col-sm-12"
              :class="showConectores ? ' col-md-3' : ' col-md-4'"
            >
              <div class="form-group form-group-mes xs-even">
                <label class="label-buscador" for="destino">
                  <i class="fa fa-spinner fa-pulse" v-if="preloader"></i>
                  <i class="fa fa-calendar" v-else></i>
                  <span>Mes de Salida</span>
                </label>
                <v-select
                  v-if="!preloader"
                  v-model="mes"
                  label="nombre"
                  :reduce="reduce"
                  :options="meses"
                  :tabindex="1"
                  :disabled="!isMeses"
                  :searchable="false"
                  placeholder="Seleccionar"
                >
                  <template slot="option" slot-scope="option">
                    <i class="fa fa-calendar"></i>
                    <span v-html="option.nombre"></span>
                  </template>
                </v-select>
              </div>
            </div>

            <div
              class="col-xs-12 col-sm-12"
              :class="showConectores ? ' col-md-3' : ' col-md-4'"
            >
              <div class="form-group form-group-salida xs-odd">
                <label class="label-buscador" for="salida">
                  <i class="fa fa-spinner fa-pulse" v-if="preloader"></i>
                  <i class="fa fa-map-marker" v-else></i>
                  <span>Ciudad de Inicio</span>
                </label>
                <v-select
                  v-if="!preloader"
                  v-model="salida"
                  label="nombre"
                  :reduce="reduce"
                  :options="salidas"
                  :tabindex="2"
                  :disabled="!isSalidas"
                  placeholder="Seleccionar"
                >
                  <template slot="selected-option" slot-scope="option">
                    <span v-html="option.nombre"></span>
                  </template>

                  <template slot="option" slot-scope="option">
                    <i class="fa fa-map-marker"></i>
                    <span v-html="option.nombre"></span>
                  </template>
                </v-select>
              </div>
            </div>

            <div
              class="col-xs-12 col-sm-12"
              :class="showConectores ? ' col-md-3' : ' col-md-4'"
            >
              <div class="form-group form-group-destino xs-even">
                <label class="label-buscador" for="destino">
                  <i class="fa fa-spinner fa-pulse" v-if="preloader"></i>
                  <i class="fa fa-plus" v-else></i>
                  <span>Ciudades de Destino</span>
                </label>
                <v-select
                  v-if="!preloader"
                  multiple
                  v-model="destino"
                  label="nombre"
                  :reduce="reduce"
                  :options="destinos"
                  :tabindex="3"
                  :disabled="!isDestinos"
                  placeholder="Seleccionar"
                >
                  <template slot="selected-option" slot-scope="option">
                    <span v-html="option.nombre"></span>
                  </template>

                  <template slot="option" slot-scope="option">
                    <i class="fa fa-map-marker"></i>
                    <span v-html="option.nombre"></span>
                  </template>
                </v-select>
              </div>
            </div>

            <div class="col-xs-12 col-sm-12 col-md-3" v-if="showConectores">
              <div class="form-group form-group-proveedor xs-odd">
                <label class="label-buscador" for="destino">
                  <i class="fa fa-spinner fa-pulse" v-if="preloader"></i>
                  <i class="fa fa-suitcase" v-else></i>
                  <span>Proveedores</span>
                </label>
                <v-select
                  v-if="!preloader"
                  v-model="proveedor"
                  label="nombre"
                  :reduce="reduce"
                  :options="conectores"
                  :tabindex="4"
                  :disabled="!isConectores"
                  placeholder="Seleccionar"
                >
                  <template slot="option" slot-scope="option">
                    <i class="fa fa-suitcase"></i>
                    <span v-html="option.nombre"></span>
                  </template>
                </v-select>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xs-12 col-sm-12 col-md-1">
          <input type="hidden" name="mes_salida" :value="mes" />
          <input type="hidden" name="ciudad_salida" :value="salida" />
          <input
            type="hidden"
            name="ciudades[]"
            v-for="desId in destino"
            :key="desId"
            :value="desId"
          />
          <input type="hidden" name="proveedores[]" :value="proveedor" />

          <button
            type="submit"
            class="btn btn-primary btn-block"
            :disabled="!isBTN"
          >
            <i class="fa fa-search"></i>
            Buscar
          </button>

          <url-popover
            v-if="isAdmin"
            :url="url"
            :params="params"
            :disabled="!isBTN"
            custom-class="horizontal"
          ></url-popover>
        </div>
      </div>
    </div>
  </form>
</template>

<style lang="scss" scoped>
@media (min-width: 992px) {
  form.mkte_circuitos-buscador.buscador-horizontal
    > .list-group-item
    .row.row-0 {
    display: flex;
    width: 100%;
  }
  form.mkte_circuitos-buscador.buscador-horizontal
    > .list-group-item
    .row.row-0
    > div {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
  }
  form.mkte_circuitos-buscador.buscador-horizontal
    > .list-group-item
    .row.row-0
    > div
    > .row.row-0
    > div {
    display: flex;
  }

  form.mkte_circuitos-buscador.buscador-horizontal.is-admin
    > .list-group-item
    button.btn[type="submit"] {
    padding: 5px 10px;
    line-height: 20px;
    height: 32px;
  }
}

form.mkte_circuitos-buscador.buscador-horizontal
  > .list-group-item
  .form-group {
  padding: 10px 0 0 30px;
  width: 100%;
}
form.mkte_circuitos-buscador.buscador-horizontal
  > .list-group-item
  .form-group
  > label
  > .fa {
  left: 10px;
  width: 15px;
}

/** BTN */
form.mkte_circuitos-buscador.buscador-horizontal
  > .list-group-item
  button.btn[type="submit"] {
  padding: 15px 10px;
  line-height: 25px;
}
</style>